module.exports = __webpack_public_path__ + "static/media/news-tim-koehler.55f8eec3.jpg";